module.exports = __webpack_public_path__ + "static/team_3-454761d0eeb815919bf6423aa0b38f98.jpg";